module.exports = __webpack_public_path__ + "static/media/consultadeuda.d4324963.png";